<ng-template #confirmModal let-close="close" let-dismiss="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>

    <my-global-icon iconName="cross" aria-label="Close" role="button" (click)="dismiss()"></my-global-icon>
  </div>

  <div class="modal-body" >
    <div [innerHtml]="message"></div>

    <div *ngIf="inputLabel && expectedInputValue" class="form-group mt-3">
      <label for="confirmInput">{{ inputLabel }}</label>
      <input type="text" id="confirmInput" name="confirmInput" [(ngModel)]="inputValue" />
    </div>
  </div>

  <div class="modal-footer inputs">
    <input
      type="button" role="button" i18n-value value="Cancel" class="peertube-button grey-button"
      (click)="dismiss()" (key.enter)="dismiss()"
    >

    <input
      ngbAutofocus
      type="submit" [value]="confirmButtonText" class="peertube-button orange-button" [disabled]="isConfirmationDisabled()"
      (click)="close()" (key.enter)="confirm()"
    >
  </div>
</ng-template>
